
import '@tensorflow/tfjs-backend-webgl';
import '@tensorflow/tfjs-backend-webgpu';

// import * as mpPose from '@mediapipe/pose';
// import * as tfjsWasm from '@tensorflow/tfjs-backend-wasm';
import * as tf from '@tensorflow/tfjs-core';

// tfjsWasm.setWasmPaths(
//   `https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-backend-wasm@${tfjsWasm.version_wasm}/dist/`);

import * as posedetection from '@tensorflow-models/pose-detection';
import { poseSimilarity } from './pose_similarity';

import { Camera } from './camera';
import { RendererWebGPU } from './renderer_webgpu';
import { RendererCanvas2d } from './renderer_canvas2d';
// import { setupDatGui } from './option_panel';
import { STATE } from './params';
import { setBackendAndEnvFlags } from './util';

// import shvanasanaPose from '../images/shvanasana.png';
// import agnistambasanaPose from '../images/agnistambasana.png';
// import virabhadrasanaPose from '../images/virabhadrasana.png';

let detector, camera;
let rafId;
let renderer = null;
let yogaPoseRenderer = null;
let useGpuRenderer = false;
let yogaPoses = null;
let scoreElement = document.getElementById('similarityresult')
let animate = false

async function createDetector() {
  switch (STATE.model) {
    // case posedetection.SupportedModels.PoseNet:
    //   return posedetection.createDetector(STATE.model, {
    //     quantBytes: 4,
    //     architecture: 'MobileNetV1',
    //     outputStride: 16,
    //     inputResolution: { width: 500, height: 500 },
    //     multiplier: 0.75
    //   });
    // case posedetection.SupportedModels.BlazePose:
    //   const runtime = STATE.backend.split('-')[0];
    //   if (runtime === 'mediapipe') {
    //     return posedetection.createDetector(STATE.model, {
    //       runtime,
    //       modelType: STATE.modelConfig.type,
    //       solutionPath:
    //         `https://cdn.jsdelivr.net/npm/@mediapipe/pose@${mpPose.VERSION}`
    //     });
    //   } else if (runtime === 'tfjs') {
    //     return posedetection.createDetector(
    //       STATE.model, { runtime, modelType: STATE.modelConfig.type });
    //   }
    case posedetection.SupportedModels.MoveNet:
      let modelType;
      if (STATE.modelConfig.type == 'lightning') {
        modelType = posedetection.movenet.modelType.SINGLEPOSE_LIGHTNING;
      } else if (STATE.modelConfig.type == 'thunder') {
        modelType = posedetection.movenet.modelType.SINGLEPOSE_THUNDER;
      } else if (STATE.modelConfig.type == 'multipose') {
        modelType = posedetection.movenet.modelType.MULTIPOSE_LIGHTNING;
      }
      const modelConfig = { modelType };

      if (STATE.modelConfig.customModel !== '') {
        modelConfig.modelUrl = STATE.modelConfig.customModel;
      }
      if (STATE.modelConfig.type === 'multipose') {
        modelConfig.enableTracking = STATE.modelConfig.enableTracking;
      }
      return posedetection.createDetector(STATE.model, modelConfig);
  }
}

// async function checkGuiUpdate() {
//   if (STATE.isTargetFPSChanged || STATE.isSizeOptionChanged) {
//     camera = await Camera.setupCamera(STATE.camera);
//     STATE.isTargetFPSChanged = false;
//     STATE.isSizeOptionChanged = false;
//   }

//   if (STATE.isModelChanged || STATE.isFlagChanged || STATE.isBackendChanged) {
//     STATE.isModelChanged = true;

//     window.cancelAnimationFrame(rafId);

//     if (detector != null) {
//       detector.dispose();
//     }

//     if (STATE.isFlagChanged || STATE.isBackendChanged) {
//       await setBackendAndEnvFlags(STATE.flags, STATE.backend);
//     }

//     try {
//       detector = await createDetector(STATE.model);
//     } catch (error) {
//       detector = null;
//       alert(error);
//     }

//     STATE.isFlagChanged = false;
//     STATE.isBackendChanged = false;
//     STATE.isModelChanged = false;
//   }
// }

async function renderResult() {
  if (camera.video.readyState < 2) {
    await new Promise((resolve) => {
      camera.video.onloadeddata = () => {
        resolve(video);
      };
    });
  }

  let poses = null;
  let canvasInfo = null;

  // Detector can be null if initialization failed (for example when loading
  // from a URL that does not exist).
  if (detector != null) {
    if (useGpuRenderer && STATE.model !== 'PoseNet') {
      throw new Error('Only PoseNet supports GPU renderer!');
    }
    // Detectors can throw errors, for example when using custom URLs that
    // contain a model that doesn't provide the expected output.
    try {
      if (useGpuRenderer) {
        const [posesTemp, canvasInfoTemp] = await detector.estimatePosesGPU(
          camera.video,
          { maxPoses: STATE.modelConfig.maxPoses, flipHorizontal: false },
          true);
        poses = posesTemp;
        canvasInfo = canvasInfoTemp;
      } else {
        poses = await detector.estimatePoses(
          camera.video,
          { maxPoses: STATE.modelConfig.maxPoses, flipHorizontal: false });
      }
    } catch (error) {
      detector.dispose();
      detector = null;
      alert(error);
    }
  }
  const rendererParams = useGpuRenderer ?
    [camera.video, poses, canvasInfo, STATE.modelConfig.scoreThreshold] :
    [camera.video, poses, STATE.isModelChanged];
  renderer.draw(rendererParams);

  if (poses && poses[0] && yogaPoses && yogaPoses[0]) {
    comparePose(poses[0], yogaPoses[0]);
  }
}

async function renderPrediction() {
  // await checkGuiUpdate();

  if (!STATE.isModelChanged) {
    await renderResult();
  }
  if (animate) {
    rafId = requestAnimationFrame(renderPrediction);
  }
};

export function stopAnimation() {
  animate = false
}

function comparePose(pose1, pose2) {
  const strategy = 'weightedDistance' // document.getElementById('similaritystrategy').value;
  const score = poseSimilarity(pose1, pose2, { strategy: strategy });
  // console.log('score', score);
  const scoreElement = document.getElementById('similarityresult')
  scoreElement.value = score;
  let event = new Event('change')
  scoreElement.dispatchEvent(event)
};


function loadYogaPoseImage() {
  // const yogaPoseSelect = document.getElementById('yogaposes');
  const yogaPoseImage = document.getElementById('yogeposeimg');

  // switch (yogaPoseSelect.value) {
  //   case 'shvanasana':
  //     yogaPoseImage.src = shvanasanaPose;
  //     break;

  //   case 'agnistambasana':
  //     yogaPoseImage.src = agnistambasanaPose;
  //     break;

  //   case 'virabhadrasana':
  //     yogaPoseImage.src = virabhadrasanaPose;
  //     break;

  //   default:
  //     break;
  // }
  yogaPoseImage.onload = async function () {
    // const urlParams = new URLSearchParams(window.location.search);
    const yogaPoseImage = document.getElementById('yogeposeimg');
    const yogaPoseCanvas = document.getElementById('yogaposeoutput');
    yogaPoseCanvas.width = yogaPoseImage.width;
    yogaPoseCanvas.height = yogaPoseImage.height;
    const isWebGPU = STATE.backend === 'tfjs-webgpu';
    // const importVideo = (urlParams.get('importVideo') === 'true') && isWebGPU;
    const importVideo = false;

    let yogaCanvasInfo = null;

    // if (useGpuRenderer) {
    //   yogaPoseRenderer = new RendererWebGPU(yogaPoseCanvas, importVideo);
    // } else {
    // }
    yogaPoseRenderer = new RendererCanvas2d(yogaPoseCanvas, false);

    if (useGpuRenderer && STATE.model !== 'PoseNet') {
      throw new Error('Only PoseNet supports GPU renderer!');
    }
    // Detectors can throw errors, for example when using custom URLs that
    // contain a model that doesn't provide the expected output.
    try {
      // if (useGpuRenderer) {
      //   const [posesTemp, canvasInfoTemp] = await detector.estimatePosesGPU(
      //     yogaPoseImage,
      //     { maxPoses: STATE.modelConfig.maxPoses, flipHorizontal: false },
      //     true);
      //   yogaPoses = posesTemp;
      //   yogaCanvasInfo = canvasInfoTemp;
      // } else {
      yogaPoses = await detector.estimatePoses(
        yogaPoseImage,
        { maxPoses: STATE.modelConfig.maxPoses, flipHorizontal: false });
      // }
    } catch (error) {
      detector.dispose();
      detector = null;
      alert(error);
    }

    const rendererParams = useGpuRenderer ?
      [yogaPoseImage, yogaPoses, yogaCanvasInfo, STATE.modelConfig.scoreThreshold] :
      [yogaPoseImage, yogaPoses, STATE.isModelChanged];
    yogaPoseRenderer.draw(rendererParams);
  };
};

export async function initAiTracker(params) {
  STATE.camera = params.camera
  STATE.backend = params.backend
  STATE.flags = params.flags
  STATE.modelConfig = params.modelConfig
  STATE.model = params.model
  STATE.lastTFJSBackend = params.lastTFJSBackend

  // await setupDatGui(urlParams);

  const isWebGPU = STATE.backend === 'tfjs-webgpu';
  const importVideo = (params['importVideo'] === 'true') && isWebGPU;

  camera = await Camera.setup(STATE.camera);

  await setBackendAndEnvFlags(STATE.flags, STATE.backend);
  await tf.ready();
  detector = await createDetector();
  const canvas = document.getElementById('output');
  canvas.width = camera.video.width;
  canvas.height = camera.video.height;
  useGpuRenderer = (params['gpuRenderer'] === 'true') && isWebGPU;
  // if (useGpuRenderer) {
  //   renderer = new RendererWebGPU(canvas, importVideo);
  // } else {
  // }
  renderer = new RendererCanvas2d(canvas, true);
  animate = true
  renderPrediction();

  // const yogaPoseSelect = document.getElementById('yogaposes');
  // yogaPoseSelect.addEventListener('change', loadYogaPoseImage);
  loadYogaPoseImage();
};

export function stopVideoStream() {
  camera.video.srcObject.getTracks().forEach(function (track) {
    track.stop();
  });
}

// app();

// if (useGpuRenderer) {
//   renderer.dispose();
// }
